import moment from 'moment';

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import {
  StoreLink,
  DateLink,
} from '../../components/Links';

import { columnCreatedAt, columnUpdatedAt } from '../../components/common';

const ColumnNameTitle = styled.span`
  text-transform: capitalize;
`;

const ColumnNameSubtitle = styled.p`
  font-size: 14px;
  margin-top: -10px;
  font-weight: 600;
  margin-bottom: 0px;
`;

export const [
  columnNameAdmin,
  columnNameSeller,
] = [
  '/abandoned-carts',
  '/abandoned-carts',
].map(prefix => ({
  title: 'Cart',
  path: 'name',
  width: '100%',
  link: `${prefix}/:_id`,
  render: (record, column, props) => {
    const tableMode = props.getArchiveTableMode(props);
    return (
      <Link
        to={getRoleBasedPath(props, `${prefix}/${record._id}`)}
      >
        <ColumnNameTitle>
          {record.name || 'N/A'}
        </ColumnNameTitle>
        {
          record.email?.length
          ? (
              tableMode === 'cards'
              ? (
                  <ColumnNameSubtitle>
                    {record.email}
                  </ColumnNameSubtitle>
                )
              : ` / ${record.email}`
            )
          : null
        }
      </Link>
    );
  },
}));

export const columnCustomer = {
  title: 'Customer',
  path: 'customer',
  render: (record, column, props) => (
    record.customer?.name?.length
    && record.saleSummaries?.storeCustomer
    ? (
        <Link
          to={getRoleBasedPath(props, `/customers/${
            record.saleSummaries?.storeCustomer
          }`)}
        >
          {record.customer.name}
        </Link>
      )
    : '-'
  ),
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  render: (record, column, props) => (
    record.store
    ? (
        <StoreLink
          style={{ textTransform: 'capitalize' }}
          location={props.location}
          subject={record.store}
          pathname={getRoleBasedPath(props, '/orders')}
        />
      )
    : 'N/A'
  ),
};

export const columnLastSentAt = {
  path: 'lastSentAt',
  title: 'Last Sent At',
  sort: 'lastSent',
  render: (record, column, props) => (
    !record.sentCount
    ? '-'
    : (
        <DateLink
          date={record.lastSentAt}
          location={props.location}
          pathname={getRoleBasedPath(props, '/orders')}
        >
          {moment(record.lastSentAt).calendar(null, {
            sameElse: 'lll',
          })}
        </DateLink>
      )
  ),
};

export const columntSentCount = {
  title: 'Sent Count',
  path: 'sentCount',
  align: 'right',
  render: (record) => (
    record?.sentCount > 0
    ? record?.sentCount
    : '-'
  ),
};

// export const columnItems = {
//   path: 'items',
//   render: (record, column, props) => (
//     record.items > 0
//     ? (
//         <ProductCollectionLink
//           location={props.location}
//           subject={record}
//           pathname={getRoleBasedPath(props, '/products')}
//           valuePath="_id"
//         >
//           {`${record.products}`}
//         </ProductCollectionLink>
//       )
//     : '0'
//   ),
// };

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  columnCustomer,
  columnCreatedAt,
  columnUpdatedAt,
  columnLastSentAt,
  columntSentCount,
];

export const SELLER = [
  columnNameSeller,
  columnCustomer,
  columnCreatedAt,
  columnUpdatedAt,
  columnLastSentAt,
  columntSentCount,
];
